module.exports = __webpack_public_path__ + "img/join-banner-md.9fba52d6.jpg";